import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import generalService from './generalService'

// Get Campuses
export const GetCampuses = createAsyncThunk('campus-list', async (_, thunkAPI) => {
  try {
    return await generalService.getCampuses()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Start Impersonation
export const StartImpersonate = createAsyncThunk(
  'start-impersonate',
  async (data: {}, thunkAPI) => {
    try {
      return await generalService.startImpersonate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response)
      }
    }
  }
)

// Stop Impersonation
export const StopImpersonate = createAsyncThunk('stop-impersonate', async (data: {}, thunkAPI) => {
  try {
    return await generalService.stopImpersonate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetFaculties = createAsyncThunk('faculties-list', async (_, thunkAPI) => {
  try {
    return await generalService.getFaculties()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetDepartments = createAsyncThunk('departments-list', async (_, thunkAPI) => {
  try {
    return await generalService.getDepartments()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const Notifications = createAsyncThunk('notification', async (_, thunkAPI) => {
  try {
    return await generalService.notifications()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ReadNotification = createAsyncThunk('read-notify', async (id: string, thunkAPI) => {
  try {
    return await generalService.readNotification(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetUniversities = createAsyncThunk('get-universities', async (_, thunkAPI) => {
  try {
    return await generalService.getUniversities()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSchools = createAsyncThunk('get-schools', async (_, thunkAPI) => {
  try {
    return await generalService.getSchools()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSchoolSubjects = createAsyncThunk('get-school-subjects', async (_, thunkAPI) => {
  try {
    return await generalService.getSchoolSubjects()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSchoolClasses = createAsyncThunk('get-school-classes', async (_, thunkAPI) => {
  try {
    return await generalService.getSchoolClasses()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetKankorTerms = createAsyncThunk('get-kankor-terms', async (id: string, thunkAPI) => {
  try {
    return await generalService.getKankorTerms(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetTerms = createAsyncThunk('get-terms', async (_, thunkAPI) => {
  try {
    return await generalService.getTerms()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetClasses = createAsyncThunk('get-classes', async (__, thunkAPI) => {
  try {
    return await generalService.getClasses()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSubjectsTypes = createAsyncThunk('get-subject-types', async (_, thunkAPI) => {
  try {
    return await generalService.getSubjectTypes()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSemesters = createAsyncThunk('get-semesters', async (_, thunkAPI) => {
  try {
    return await generalService.getSemesters()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAcademicRanks = createAsyncThunk('get-academic-ranks', async (_, thunkAPI) => {
  try {
    return await generalService.getAcademicRanks()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSessions = createAsyncThunk('get-sessions', async (_, thunkAPI) => {
  try {
    return await generalService.getSessions()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetDays = createAsyncThunk('get-days', async (_, thunkAPI) => {
  try {
    return await generalService.getDays()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetEducationDegrees = createAsyncThunk(
  'get-educations-degree',
  async (_, thunkAPI) => {
    try {
      return await generalService.getEducationDegrees()
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetPositions = createAsyncThunk('get-positions', async (_, thunkAPI) => {
  try {
    return await generalService.getPositions()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSubjects = createAsyncThunk('get-subjects', async (_, thunkAPI) => {
  try {
    return await generalService.getSubjects()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetLanguages = createAsyncThunk('get-languages', async (_, thunkAPI) => {
  try {
    return await generalService.getLanguages()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetRelatives = createAsyncThunk('get-relatives', async (_, thunkAPI) => {
  try {
    return await generalService.getRelatives()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetProvinces = createAsyncThunk('get-provinces', async (_, thunkAPI) => {
  try {
    return await generalService.getProvinces()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetDistricts = createAsyncThunk('get-districts', async (_, thunkAPI) => {
  try {
    return await generalService.getDistricts()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetNationalities = createAsyncThunk('get-countries', async (_, thunkAPI) => {
  try {
    return await generalService.getNationalities()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetCurrencies = createAsyncThunk('get-currencies', async (_, thunkAPI) => {
  try {
    return await generalService.getCurrencies()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetCompanies = createAsyncThunk('get-companies', async (_, thunkAPI) => {
  try {
    return await generalService.getCompanies()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetFinanceIncomeCategories = createAsyncThunk(
  'get-finance-income-categories',
  async (_, thunkAPI) => {
    try {
      return await generalService.getFinanceIncomeCategories()
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetFinanceExpenseCategories = createAsyncThunk(
  'get-finance-expense-categories',
  async (_, thunkAPI) => {
    try {
      return await generalService.getFinanceExpenseCategories()
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetFinanceSubCategories = createAsyncThunk(
  'get-finance-sub-categories',
  async (id: string, thunkAPI) => {
    try {
      return await generalService.getFinanceSubCategories(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)
//dphs
export const GetSchoolCompanies = createAsyncThunk('get-school-companies', async (_, thunkAPI) => {
  try {
    return await generalService.getSchoolCompanies()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSchoolFinanceIncomeCategories = createAsyncThunk(
  'get-school-finance-income-categories',
  async (_, thunkAPI) => {
    try {
      return await generalService.getSchoolFinanceIncomeCategories()
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetSchoolFinanceExpenseCategories = createAsyncThunk(
  'get-school-finance-expense-categories',
  async (_, thunkAPI) => {
    try {
      return await generalService.getSchoolFinanceExpenseCategories()
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetSchoolFinanceSubCategories = createAsyncThunk(
  'get-school-finance-sub-categories',
  async (id: string, thunkAPI) => {
    try {
      return await generalService.getSchoolFinanceSubCategories(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetSchoolPositions = createAsyncThunk('get-school-positions', async (_, thunkAPI) => {
  try {
    return await generalService.getSchoolPositions()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetPersianMonths = createAsyncThunk('get-persian-months', async (_, thunkAPI) => {
  try {
    return await generalService.getPersianMonths()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetClassRooms = createAsyncThunk('get-class-rooms', async (id: string, thunkAPI) => {
  try {
    return await generalService.getClassRooms(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetClassRoomStudents = createAsyncThunk(
  'get-class-room-students',
  async (
    {school_class_id, class_room_id}: {school_class_id: string; class_room_id: string},
    thunkAPI
  ) => {
    try {
      const response = await generalService.getClassRoomStudents(school_class_id, class_room_id)
      return response
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
      throw error
    }
  }
)

type GeneralState = {
  general: any
  notification: any
}

const initialState: GeneralState = {
  general: [],
  notification: [],
}

export const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(GetCampuses.fulfilled, (state, action: PayloadAction<any>) => {
      state.general = action.payload
    })
    builder.addCase(GetFaculties.fulfilled, (state, action: PayloadAction<any>) => {
      state.general = action.payload
    })
    builder.addCase(Notifications.fulfilled, (state, action: PayloadAction<any>) => {
      state.notification = action.payload
    })
  },
})

export const {reset} = generalSlice.actions
export default generalSlice.reducer
